import { render, staticRenderFns } from "./Form_dlgkbb.vue?vue&type=template&id=47273c5e"
import script from "./Form_dlgkbb.vue?vue&type=script&lang=js"
export * from "./Form_dlgkbb.vue?vue&type=script&lang=js"
import style0 from "./Form_dlgkbb.vue?vue&type=style&index=0&id=47273c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports